// Flag and competing copy under the account name, never in the action column.
// The action column is 128px; a sentence there wraps into a tall stack of
// amber words. The account cell has the width.

import type { BankRequest } from '../api/types';
import {
  competingAskLine, competingCountOf, competingMarkLine, flagReasonsLine, flaggedTitle,
  isFlaggedRequest,
} from './bankRequest.ts';

type FlagRequest = Pick<
  BankRequest, 'exclusion_reason' | 'exclusion_detail' | 'competing_count' | 'reasons'
>;

// Total pending asks on this Account. When set, the approver mark ("Competing · N asks").
// When omitted, the strategist mark ("N others asked") from the request's competing_count.
function competingLine(request: FlagRequest | null, competingTotal?: number): string {
  return competingTotal != null
    ? competingMarkLine(competingTotal)
    : competingAskLine(competingCountOf(request));
}

// Every reason the gate named, not only the first.
function flaggedPhrase(request: FlagRequest | null): string | null {
  return isFlaggedRequest(request) ? flagReasonsLine(request) : null;
}

// The same two marks as small chips on the account's own line, for the 34px Available rows.
// The full sentence is the hover; a reason is too long to show at 34px beside the name.
export function RequestFlagChips({
  request,
  competingTotal,
}: {
  request: FlagRequest | null;
  competingTotal?: number;
}) {
  const competingText = competingLine(request, competingTotal);
  const phrase = flaggedPhrase(request);
  if (!competingText && !phrase) return null;
  return (
    <>
      {competingText ? (
        <span className="ovflag competing" title={competingText}>
          {competingTotal != null ? `${competingTotal} asks` : 'Others asked'}
        </span>
      ) : null}
      {phrase ? (
        <span className="ovflag competitor" title={flaggedTitle(request, phrase)}>
          Flagged
        </span>
      ) : null}
    </>
  );
}

export function RequestFlagNotes({
  request,
  competingTotal,
}: {
  request: FlagRequest | null;
  competingTotal?: number;
}) {
  const competingText = competingLine(request, competingTotal);
  const phrase = flaggedPhrase(request);

  if (!competingText && !phrase) return null;
  return (
    <div className="requestflags">
      {competingText ? (
        <div className="requestcompeting">{competingText}</div>
      ) : null}
      {phrase ? (
        <div
          className="requestflagged"
          title={request?.exclusion_detail || phrase}
        >
          Flagged — {phrase}
        </div>
      ) : null}
    </div>
  );
}
